import { createAction, handleActions } from "redux-actions";

import config from "appConfig";
import {
  api,
  checkEmptyObject,
  formatDate
} from "../../../services";

import {
  creditAdminInterface,
  rootReducerInterface,
} from "../../../typings/interfaces";
import { AdsSortOption, CreditsLog, CreditsLogList, CreditsLogListParsed, CreditsLogParsed } from "../../../models";

const parseCreditsLogData = (creditsLog: CreditsLog[]): CreditsLogParsed[] => {
  return creditsLog.map((log) => {
    return {
      adminId: log.adminId,
      adminEmail: log.adminEmail,
      createdAt: formatDate(log.createdAt, config.dateFormat),
      newBalance: log.newBalance,
      oldBalance: log.oldBalance,
      addedBalance: parseFloat((log.newBalance - log.oldBalance).toFixed(2)) > 0 ? `+${Number(parseFloat((log.newBalance - log.oldBalance).toFixed(2)))}` : Number(parseFloat((log.newBalance - log.oldBalance).toFixed(2))),
      reason: log.reason,
      userId: log.userId,
      email: log.email
    }
  });
}

const CREDITS_ADD = "CREDITS_ADD";
const CREDITS_LOG_GET = "CREDITS_LOG_GET";

// ACTIONS

// Add credits
export const addCredits = createAction(
  CREDITS_ADD,
  async (
    id: string,
    data: { amount: number, reason: string },
    callback?: (success: boolean) => void
  ) => {
    try {
      await api.Credit.add(id, data);
      callback && callback(true);
    } catch (error) {
      callback && callback(false);
      return false;
    }
  }
);

// Get credits log
export const getCreditsLog = createAction(
  CREDITS_LOG_GET,
  async (
    queryParams,
    callback?: (creditsLog: CreditsLogListParsed | Boolean) => void
  ) => {

    const searchParams = {
      ...queryParams,
      sortOption: AdsSortOption.DateDesc,
      itemPerPage: config.maxAdPerPage / 4,
    }

    let creditsLog: CreditsLogList;
    try {

      creditsLog = await api.Credit.log(searchParams);

      if (!checkEmptyObject(creditsLog)) {
        callback && callback(false);
        return null;
      }

      const data = {
        data: parseCreditsLogData(creditsLog.data),
        count: creditsLog.count,
        page: creditsLog.currentPage,
        nextPage: creditsLog.nextPage,
        previousPage: creditsLog.previousPage,
      }

      callback && callback(data);
      return data;
    } catch (error) {
      callback && callback(false);
      return null;
    }
  }
);

// SELECTORS
export const selectCreditsLog = (state: rootReducerInterface) =>
  state.admin.credit.log;

// INITIAL STATE
const initialState: creditAdminInterface = {
  log: null
};


// REDUCERS
const creditReducers = {
  getCreditsLog: (state: creditAdminInterface, { payload }) => ({
    ...state,
    log: !payload ? {} : payload
  })
};

export default handleActions(
  {
    [CREDITS_LOG_GET]: creditReducers.getCreditsLog
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserPage/credit.ducks.ts